import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard } from 'lucide-react';
export function HeroSection() {
  const scrollToPrecio = () => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-[#0A0A0A] text-white pt-16 md:pt-24 pb-10 md:pb-16 px-4" data-id="element-26">
      <div className="max-w-6xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-5 md:space-y-8" data-id="element-28">
          <h1 className="font-bebas text-4xl md:text-8xl lg:text-9xl tracking-wider text-white" data-id="element-29">
            LA CORONA DE LOS
            <br data-id="element-30" />
            QUE SABEN LLEGAR.
          </h1>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="grid grid-cols-2 gap-3 md:gap-6 max-w-4xl mx-auto" data-id="element-31">
            <div className="overflow-hidden" data-id="element-32">
              <img src="https://cdn.magicpatterns.com/uploads/8oLkn9KRQRM8ByFjdGBoCX/Misery_perfil_1.webp" alt="Modelo portando la gorra Misery Black & Magenta" className="w-full h-[220px] md:h-[400px] object-cover object-top hover:scale-105 transition-transform duration-700" data-id="element-33" />
            </div>
            <div className="overflow-hidden" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/h9ursoQWAJfg7p7gztgvxw/Miserey_hats_balck_2.png" alt="Gorra Misery Black & Magenta vista frontal" className="w-full h-[220px] md:h-[400px] object-cover hover:scale-105 transition-transform duration-700" data-id="element-35" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3,
          duration: 0.8
        }} className="max-w-3xl mx-auto space-y-4 md:space-y-6" data-id="element-36">
            <p className="font-inter text-base md:text-xl text-gray-300 leading-relaxed" data-id="element-37">
              <span className="text-misery-magenta font-bold" data-id="element-38">
                "Misery Black & Magenta"
              </span>
              : Edición limitada de 100 unidades. Bordado en 3D, corona metálica
              y el icónico forro de seda magenta. Si no la portas tú, alguien
              más lo hará.
            </p>

            <button onClick={scrollToPrecio} className="bg-misery-purple hover:bg-misery-magenta transition-all duration-300 text-white font-bebas text-xl md:text-3xl px-8 md:px-12 py-4 md:py-5 tracking-wider transform hover:scale-105" data-id="element-39">
              CONSÍGUELO AHORA
            </button>

            <div className="flex items-center justify-center gap-3 text-xs md:text-sm text-gray-400" data-id="element-40">
              <CreditCard className="w-4 h-4 md:w-5 md:h-5" data-id="element-41" />
              <span className="font-inter" data-id="element-42">
                Pago seguro |{' '}
                <span className="text-misery-magenta font-semibold" data-id="element-43">
                  10 unidades vendidas hoy
                </span>
              </span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}